import { ASSESSMENT_TYPES } from './actions'

const initialState = {
  loading: false,
  error: null,
  currentAssessment: {
    assessment_id: '',
    assessment_set_id: '',
    assessment_assigned_id: '',
    instructions: '',
    questions: null,
    // total_questions: 0,
    responses: {},
  },

  activeAssessments: {
    loading: false,
    error: null,
    data: [],
  },
  completedAssessments: {
    loading: false,
    error: null,
    data: [],
  },

  activeAssessmentsFilters: {
    duration: [],
    assessmentType: [],
    search: '',
  },

  completedAssessmentsFilters: {
    timeFilter: [],
    assessmentType: [],
    search: '',
  },

  reports: {
    data: [],
    loading: false,
    error: null,
  },

  savingResponse: false,
  savingResponseError: null,
}

const assessmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case ASSESSMENT_TYPES.FETCH_QUESTIONS_REQUEST:
      return {
        ...state,
        loading: true,
      }

    case ASSESSMENT_TYPES.FETCH_QUESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        currentAssessment: {
          ...state.currentAssessment,
          questions: action.payload.data,
          // total_questions: action.payload.data.total_questions,
        },
      }

    case ASSESSMENT_TYPES.FETCH_QUESTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    case ASSESSMENT_TYPES.SET_CURRENT_ASSESSMENT_ID:
      return {
        ...state,
        currentAssessment: {
          ...state.currentAssessment,
          assessment_id: action.payload.assessment_id,
          assessment_set_id: action.payload.assessment_set_id,
          assessment_assigned_id: action.payload.assessment_assigned_id,
          startTime: action.payload.startTime,
          endTime: action.payload.endTime,
          duration: action.payload.duration,
          title: action.payload.title,
          type: action.payload.type,
        },
      }

    case ASSESSMENT_TYPES.SAVE_QUESTION_RESPONSE:
      return {
        ...state,
        currentAssessment: {
          ...state.currentAssessment,
          responses: {
            ...state.currentAssessment.responses,
            [action.payload.questionId]: action.payload.answer,
          },
        },
      }

    case ASSESSMENT_TYPES.FETCH_ACTIVE_ASSESSMENTS_REQUEST:
      return {
        ...state,
        activeAssessments: {
          ...state.activeAssessments,
          loading: true,
        },
      }

    case ASSESSMENT_TYPES.FETCH_ACTIVE_ASSESSMENTS_SUCCESS:
      return {
        ...state,
        activeAssessments: {
          loading: false,
          error: null,
          data: action.payload?.data || [],
        },
      }

    case ASSESSMENT_TYPES.FETCH_ACTIVE_ASSESSMENTS_FAILURE:
      return {
        ...state,
        activeAssessments: {
          ...state.activeAssessments,
          loading: false,
          error: action.payload,
        },
      }

    case ASSESSMENT_TYPES.FETCH_COMPLETED_ASSESSMENTS_REQUEST:
      return {
        ...state,
        completedAssessments: {
          ...state.completedAssessments,
          loading: true,
        },
      }

    case ASSESSMENT_TYPES.FETCH_COMPLETED_ASSESSMENTS_SUCCESS:
      return {
        ...state,
        completedAssessments: {
          loading: false,
          error: null,
          data: action.payload.data,
        },
      }

    case ASSESSMENT_TYPES.FETCH_COMPLETED_ASSESSMENTS_FAILURE:
      return {
        ...state,
        completedAssessments: {
          ...state.completedAssessments,
          loading: false,
          error: action.payload,
        },
      }

    case ASSESSMENT_TYPES.SET_ACTIVE_ASSESSMENT_FILTERS:
      return {
        ...state,
        activeAssessmentsFilters: action.payload,
      }

    case ASSESSMENT_TYPES.SET_COMPLETED_ASSESSMENT_FILTERS:
      return {
        ...state,
        completedAssessmentsFilters: action.payload,
      }

    case ASSESSMENT_TYPES.SET_CURRENT_ASSESSMENT_INSTRUCTIONS:
      return {
        ...state,
        currentAssessment: {
          ...state.currentAssessment,
          instructions: action.payload,
        },
      }

    case ASSESSMENT_TYPES.FETCH_REPORTS_REQUEST:
      return {
        ...state,
        reports: {
          ...state.reports,
          loading: true,
          error: null,
        },
      }

    case ASSESSMENT_TYPES.FETCH_REPORTS_SUCCESS:
      return {
        ...state,
        reports: {
          data: action.payload,
          loading: false,
          error: null,
        },
      }

    case ASSESSMENT_TYPES.RESET_RESPONSES:
      return {
        ...state,
        currentAssessment: {
          ...state.currentAssessment,
          responses: {},
        },
      }

    case ASSESSMENT_TYPES.FETCH_REPORTS_FAILURE:
      return {
        ...state,
        reports: {
          ...state.reports,
          loading: false,
          error: action.payload,
        },
      }

    case ASSESSMENT_TYPES.SUBMIT_ASSESSMENT_SUCCESS:
      return {
        ...state,
        currentAssessment: null, // Clear current assessment after successful submission
        error: null,
      }

    case ASSESSMENT_TYPES.SUBMIT_ASSESSMENT_FAILURE:
      return {
        ...state,
        error: action.payload,
      }

    case ASSESSMENT_TYPES.SAVE_RESPONSE_REQUEST:
      return {
        ...state,
        savingResponse: true,
        saveResponseError: null,
      }

    case ASSESSMENT_TYPES.SAVE_RESPONSE_SUCCESS:
      return {
        ...state,
        savingResponse: false,
        currentAssessment: {
          ...state.currentAssessment,
          responses: action.questionType
            ? // For communication assessment (paragraphReading & audioQuestion)
              {
                ...state.currentAssessment.responses,
                [action.questionType]: state.currentAssessment.responses[
                  action.questionType
                ]
                  ? state.currentAssessment.responses[action.questionType].map(
                      q =>
                        q.questionId === action.payload.questionId
                          ? {
                              ...q,
                              responses: q.responses.some(
                                r => r.subQuestionId === action.subQuestionId
                              )
                                ? q.responses.map(r =>
                                    r.subQuestionId === action.subQuestionId
                                      ? {
                                          ...r,
                                          selectedOption: action.payload.answer,
                                        }
                                      : r
                                  )
                                : [
                                    ...q.responses,
                                    {
                                      subQuestionId: action.subQuestionId,
                                      selectedOption: action.payload.answer,
                                    },
                                  ],
                            }
                          : q
                    )
                  : [
                      {
                        questionId: action.payload.questionId,
                        responses: [
                          {
                            subQuestionId: action.subQuestionId,
                            selectedOption: action.payload.answer,
                          },
                        ],
                      },
                    ],
              }
            : // For behavior assessment - simple question:answer format
              {
                ...state.currentAssessment.responses,
                [action.payload.questionId]: action.payload.answer,
              },
        },
      }

    case ASSESSMENT_TYPES.SAVE_RESPONSE_FAILURE:
      return {
        ...state,
        savingResponse: false,
        saveResponseError: action.payload,
      }

    case ASSESSMENT_TYPES.STORE_VIDEO_RESPONSE:
      return {
        ...state,
        currentAssessment: {
          ...state.currentAssessment,
          responses: {
            ...state.currentAssessment.responses,
            videoResponse: state.currentAssessment.responses.videoResponse
              ? state.currentAssessment.responses.videoResponse.map(response =>
                  response.questionId === action.payload.questionId
                    ? {
                        ...response,
                        videoFileUrl: action.payload.parUrl,
                      }
                    : response
                )
              : [
                  {
                    questionId: action.payload.questionId,
                    videoFileUrl: action.payload.parUrl,
                  },
                ],
          },
        },
      }

    case ASSESSMENT_TYPES.STORE_AUDIO_RESPONSE: {
      const currentParagraphReading =
        state.currentAssessment.responses.paragraphReading || []
      return {
        ...state,
        currentAssessment: {
          ...state.currentAssessment,
          responses: {
            ...state.currentAssessment.responses,
            paragraphReading:
              currentParagraphReading.length > 0
                ? currentParagraphReading.map(response => ({
                    ...response,
                    audioUrl: action.payload.parUrl,
                  }))
                : [
                    {
                      questionId:
                        state.currentAssessment.questions?.communications?.[0]
                          ?.questionId,
                      audioUrl: action.payload.parUrl,
                      responses: [],
                    },
                  ],
          },
        },
      }
    }

    default:
      return state
  }
}

export default assessmentReducer
